// Header/footer chrome accent — deliberately separate from the site-wide red brand in tokens.css.
export const NAVY = { 700: "#0b1220", 800: "#0e1729", 900: "#131b2e" } as const;
export const AMBER = { 300: "#fbbf24", 500: "#f59e0b", 600: "#d97706", 900: "#4a2c05" } as const;
